<template>
  <div>
    <v-row>
      <v-col cols="6">
        <validation-provider :vid="uuid()" name="Type" rules="required" v-slot="{ errors }">
          <v-select
            label="Derivation Type"
            :items="derivationTypes"
            v-model="dataType.derivationType"
            @change="changeDerivationType"
          ></v-select>
          <span class="validation-message">{{ errors[0] }}</span>
        </validation-provider>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <div class="field-group-header mt-5">Type Infos</div>

    <directly v-if="dataType.derivationType === 'Directly'" :tempId="id"></directly>

    <subrange v-if="dataType.derivationType === 'Subrange'" :tempId="id"></subrange>

    <enumerated v-if="dataType.derivationType === 'Enumerated'" :tempId="id"></enumerated>

    <array v-if="dataType.derivationType === 'Array'" :tempId="id"></array>

    <structure v-if="dataType.derivationType === 'Structure'" :tempId="id"></structure>
  </div>
</template>

<script>
import { find } from "lodash";
import { ValidationProvider } from "vee-validate";
import uuid from "src/mixins/uuid";
import Directly from "./Directly";
import Subrange from "./Subrange";
import Enumerated from "./Enumerated";
import Array from "./Array";
import Structure from "./Structure";

export default {
  name: "DataTypeWindow",
  props: ["id"],
  components: {
    ValidationProvider,
    Directly,
    Subrange,
    Enumerated,
    Array,
    Structure,
  },
  mixins: [uuid],
  data() {
    return {
      derivationTypes: [
        "Directly",
        "Subrange",
        "Enumerated",
        "Array",
        "Structure",
      ],
    };
  },
  computed: {
    dataType() {
      return find(this.$store.state.dataTypes, { tempId: this.id });
    },
  },
  methods: {
    changeDerivationType() {
      let name = undefined;

      switch (this.dataType.derivationType) {
        case "Subrange":
          name = "subrangeUnsigned";
          break;

        case "Enumerated":
          name = "enum";
          break;

        case "Array":
          name = "array";
          break;

        case "Structure":
          name = "struct";
          break;
      }
      this.$store.dispatch("updateDataType", {
        ...this.dataType,
        baseType: {
          name,
        },
      });
    },
  },
};
</script>
